import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import DatePicker from "components/DatePicker";
import Button from "components/Button";
import DownloadDataModal from "../DownloadDataModal";
import { useIntl } from "react-intl";
import ParkkiTheme from "themes/ParkkiTheme";
import moment from "moment";

const StyledContainer = styled.div`
  margin: ${ParkkiTheme.spacings.tiny};
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex: 1;
`;

const ItemContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  margin-right: ${(props) => (props.last ? "0px" : ParkkiTheme.spacings.tiny)};
  max-width: ${(props) => (props.last ? "120px" : "200px")};
`;

const handleDateChange = (type, newDate, fromDate, toDate, setDate) => {
  // User select date before the other datepicker
  if (type === "from" && newDate.isAfter(toDate, "day")) {
    setDate("to", newDate.valueOf());
    setDate("from", newDate.subtract(1, "day").valueOf());
    return;
  }

  // User select date after the other datepicker
  if (type === "to" && newDate.isBefore(fromDate, "day")) {
    setDate("to", newDate.valueOf());
    setDate("from", newDate.subtract(1, "day").valueOf());
    return;
  }

  return setDate(type, newDate.valueOf());
};

const Filters = ({
  filters,
  setFilter,
  onSearch,
  selectedIndicators,
  categories,
}) => {
  const intl = useIntl();

  return (
    <StyledContainer>
      <ItemContainer>
        <DatePicker
          value={filters.from}
          label={intl.messages["indicatorsScene.filters.from"]}
          onChange={(e) =>
            handleDateChange("from", e, filters.from, filters.to, setFilter)
          }
          shouldDisableDate={(date) => date.isAfter(moment(), "day")}
        />
      </ItemContainer>
      <ItemContainer>
        <DatePicker
          value={filters.to}
          label={intl.messages["indicatorsScene.filters.to"]}
          onChange={(e) =>
            handleDateChange("to", e, filters.from, filters.to, setFilter)
          }
          shouldDisableDate={(date) => date.isAfter(moment(), "day")}
        />
      </ItemContainer>
      <ItemContainer last>
        <Button
          fullWidth={false}
          label={intl.messages["components.buttons.actualize"]}
          onClick={onSearch}
        />
      </ItemContainer>
      <ItemContainer
        last
        style={{
          marginLeft: "auto",
          maxWidth: "unset",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <DownloadDataModal
          selectedIndicators={selectedIndicators}
          categories={categories}
        />
      </ItemContainer>
    </StyledContainer>
  );
};

Filters.defaultProps = {
  style: {},
  values: [],
};

Filters.propTypes = {
  filters: PropTypes.shape({}).isRequired,
  style: PropTypes.object,
  values: PropTypes.arrayOf(PropTypes.object),
};

export default Filters;
